import { Suspense } from "react";

import { Route, Routes } from "react-router-dom";

import Feature from "@kanakku/feature-module/feature";

import { billingPublicRoutes } from "@/kanakku/billingRouter.link";
import { billingLegacyRedirects } from "@/kanakku/billingLegacyRedirects";

import { LoginPage } from "@/feature-module/auth/LoginPage";

import { AuthHandoffPage } from "@/feature-module/auth/AuthHandoffPage";

import { ProtectedRoute, RootRedirect } from "./ProtectedRoute";

import { routes } from "./all_routes";



const LoadingFallback = () => (

  <div

    style={{

      display: "flex",

      justifyContent: "center",

      alignItems: "center",

      height: "100vh",

    }}

  >

    Chargement…

  </div>

);



export function AppRouter() {

  return (

    <Suspense fallback={<LoadingFallback />}>

      <Routes>

        <Route path="/" element={<RootRedirect />} />

        <Route path={routes.login} element={<LoginPage />} />

        <Route path={routes.authHandoff} element={<AuthHandoffPage />} />

        <Route

          element={

            <ProtectedRoute>

              <Feature />

            </ProtectedRoute>

          }

        >

          {billingLegacyRedirects.map((route, idx) => (
            <Route path={route.path} element={route.element} key={`legacy-${route.path}-${idx}`} />
          ))}
          {billingPublicRoutes.map((route, idx) => (

            <Route path={route.path} element={route.element} key={`${route.path}-${idx}`} />

          ))}

        </Route>

        <Route path="*" element={<RootRedirect />} />

      </Routes>

    </Suspense>

  );

}


